<div [ngClass]="{'m-t-5-m m-t-5-s': !registerPageIsVisible}">
    @if (content?.logoTrade && !registerPageIsVisible) {
    <div class="w-12">
        <img class="va-m"
             [image]="content?.logoTrade"
             [options]="{ fitIn: true }"
             [attr.height]="36"
             [attr.width]="140">
    </div>
    @if (content?.message && !showLoginForm) {
    <div class="w-12 p-t-7"
         *iCms="'message' of content; content: 'html'"></div>
    <multisite-switch-advanced (preferredStoreChange)="setShowLoginForm()"></multisite-switch-advanced>
    }
    }
</div>


@if (isTradeProspectView) {
<login-form-trade-prospect-message class="w-12 m-t-10 m-t-4-m m-t-4-s"></login-form-trade-prospect-message>
}

@if (!isTradeProspectView && showLoginForm) {
@if (!registerPageIsVisible) {
<button (click)="removePreferredStoreCookie()"
        type="button"
        class="flex flex-middle m-t-5">
    <i class="icon-arrow-simple-left flex flex-middle m-r-1"></i>
    <p class="p2">{{'Go back to Region selection' | translate}}</p>
</button>
}
<form #form="ngForm"
      class="m-t"
      method="POST"
      [attr.sl-form]="shouldRegister() ? 'register' : 'login'">
    @if (!registerPageIsVisible) {
    <!-- title -->
    <h3 class="h3">{{ 'Sign in' | translate }}</h3>
    <!-- email field (for all forms) -->
    <input-wrap class="w-12 m-t-5"
                [required]="true">
        <input class="input p-b-5-s p-t-7-s"
               cy-loginMailInput
               [muiInput]="'Email address' | translate"
               sl-input="email"
               type="email"
               maxlength="100"
               validatePattern="email"
               name="email"
               [attr.placeholder]="'Email address'"
               [(ngModel)]="tmpEmail"
               (ngModelChange)="applyTmpEmail()"
               (blur)="applyTmpEmail(true)"
               (keyup.enter)="applyTmpEmail(true)"
               autocomplete="username"
               required
               email
               #emailInput>
    </input-wrap>
    <input-wrap class="w-12 m-t-5 m-t-8-m m-t-8-s password-input"
                [required]="true">
        <input class="input p-b-5-s p-t-7-s"
               type="password"
               name="password"
               required="required"
               cy-loginPwdInput
               [(ngModel)]="data.password"
               (keyup.enter)="login()"
               [muiInput]="'Password' | translate">
    </input-wrap>
    <result class="block m-t p2"
            sl-result="login"
            cy-loginSignInMsg
            [status]="loginStatus"></result>
    <!-- reset my password -->
    <action class="m-t-6 m-t-3-s button-inline-5"
            sl-button="reset"
            [status]="passwordStatus"
            (click)="resetPassword()">
        <span>{{'Reset Your Password' | translate}}</span>
    </action>
    <div class="p2 m-t-2">
        {{'If this is your first time logging in to the new site you will need to do this' | translate}}
    </div>
    <result class="block m-b-5 p2 col-3"
            sl-result="reset"
            [status]="passwordStatus"
            [success]="'We have sent you an email with a link to reset your password.' | translate">
    </result>
    <action class="w-12 m-t-5 button"
            sl-button="login"
            cy-loginSignIn
            [status]="loginStatus"
            (click)="login()">
        <span>{{'Sign in' | translate}}</span>
    </action>
    @switch (!!content?.useAlternativeVariant) {
    @case (true) {
    <p class="m-t"
       *iCms="'alternativeVariantMessage' of content; content: 'html'"></p>
    }
    @default {
    <action class="w-12 m-t button-1"
            sl-button="register"
            cy-loginConfirm
            (click)="showRegisterForm(true)">
        <span>{{'Apply for a trade account' | translate}}</span>
    </action>
    }
    }
    }
    @if (registerPageIsVisible) {
    <form-wizard [scrollContainer]="'#login-view-layout-scroll'"
                 (stepChange)="stepChangeHandle()"
                 #formWizard>
        @if(formWizard) {
        <div class="flex flex-middle flex-justify-between m-b-7 m-b-4-m m-b-4-s p-t-3 p-b-3 b-b b-col-5 col-12 _progress"
             [style.--form-wizard-steps]="formWizard.visibleStepsSequence.length"
             [style.--form-wizard-current-step]="formWizard.currentStepIndex">
            @if (formWizard.currentStepIndex < 1)
              {
              <button
              class="flex flex-middle p2"
              (click)="showRegisterForm(false)">
                <i class="m-r-3 icon-arrow-left"
                   [style.line-height]="0"
                   [style.font-size.px]="12"></i>
                {{'Sign in' | translate}}
                </button>
                }
                @if (formWizard.currentStepIndex >= 1) {
                <button class="flex flex-middle p2"
                        (click)="formWizard.goToPrevStep()">
                    <i class="m-r-3 icon-arrow-left"
                       [style.line-height]="0"
                       [style.font-size.px]="12"></i>
                    {{'Previous step' | translate}}
                </button>
                }
                <div class="p3">
                    {{'Step' | translate}} {{(formWizard.currentStepIndex || 0) +
                    2}}/{{(formWizard.visibleStepsSequence.length || 0) + 1}}
                </div>
        </div>
        }
        <div class="m-r--4 m-b-5 m-l--4 b-b"
             *ifSize="'MS'"></div>
        <form-wizard-step id="1"
                          [order]="0">
            <login-form-trade-step-1 [data]="dataAsRegisterFormData"
                                     [(email)]="email"
                                     [content]="content"></login-form-trade-step-1>
        </form-wizard-step>
        @if (!content?.useAlternativeVariant) {
        <form-wizard-step id="2"
                          [order]="1">
            <login-form-trade-step-2 [data]="dataAsRegisterFormData"></login-form-trade-step-2>
        </form-wizard-step>
        <form-wizard-step id="3"
                          [order]="2">
            <login-form-trade-step-3 [data]="dataAsRegisterFormData"></login-form-trade-step-3>
        </form-wizard-step>
        <form-wizard-step id="4"
                          [order]="3">
            <login-form-trade-step-4 [data]="dataAsRegisterFormData"></login-form-trade-step-4>
        </form-wizard-step>
        <form-wizard-step id="5"
                          [order]="4">
            <login-form-trade-step-5 [data]="dataAsRegisterFormData"></login-form-trade-step-5>
        </form-wizard-step>
        <form-wizard-step id="6"
                          [order]="5">
            <login-form-trade-step-6 [data]="dataAsRegisterFormData"
                                     [content]="content"></login-form-trade-step-6>
        </form-wizard-step>
        @if (formWizard?.nextStep) {
        <action class="w-12 m-t-6 m-t-9-m m-t-9-s button"
                (click)="formWizard.goToNextStep()">
            <span>{{'Continue' | translate}}</span>
        </action>
        }
        @if (!formWizard?.nextStep) {
        <action class="w-12 m-t-6 m-t-9-m m-t-9-s button"
                [status]="registerStatus"
                (click)="register()">
            <span>{{'Submit Application' | translate}}</span>
        </action>
        <result class="block m-b-2 p2 m-t-1"
                sl-result="login"
                cy-loginSignUpMsg
                [status]="registerStatus"></result>
        }
        }
        <div class="m-t center">
            <button class="button-inline-5"
                    (click)="showRegisterForm(false)">{{ 'Already have an account? Sign in' | translate }}</button>
        </div>
    </form-wizard>
    }
</form>
}